import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #212121;
    line-height: 1.7;
    background-color: #ffffff;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0.5em;
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    color: #e60000;
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: #a90000;
      text-decoration: underline;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  button, input, select, textarea {
    font-family: inherit;
  }

  .container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;

    @media (min-width: 600px) {
      padding: 0 2rem;
    }
  }

  .section {
    padding: 3rem 0;

    @media (min-width: 960px) {
      padding: 5rem 0;
    }
  }

  .text-center {
    text-align: center;
  }

  .text-primary {
    color: #e60000;
  }

  .text-secondary {
    color: #000000;
  }

  .bg-primary {
    background-color: #e60000;
    color: #ffffff;
  }

  .bg-secondary {
    background-color: #000000;
    color: #ffffff;
  }

  .bg-light {
    background-color: #f5f5f5;
  }

  .mb-1 {
    margin-bottom: 0.5rem;
  }

  .mb-2 {
    margin-bottom: 1rem;
  }

  .mb-3 {
    margin-bottom: 1.5rem;
  }

  .mb-4 {
    margin-bottom: 2rem;
  }

  .mb-5 {
    margin-bottom: 3rem;
  }

  .mt-1 {
    margin-top: 0.5rem;
  }

  .mt-2 {
    margin-top: 1rem;
  }

  .mt-3 {
    margin-top: 1.5rem;
  }

  .mt-4 {
    margin-top: 2rem;
  }

  .mt-5 {
    margin-top: 3rem;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;

export default GlobalStyles;
